import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import Header from "@/components/Header";

const Privacy = () => {
  const lastUpdated = new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />

      {/* Main Content */}
      <main className="flex-1 py-16 md:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          <h1 className="font-manrope font-bold text-3xl md:text-4xl text-foreground mb-2">
            Privacy Policy
          </h1>
          <p className="text-muted-foreground mb-2">Relocation Clarity</p>
          <p className="text-sm text-muted-foreground mb-10">Last updated: {lastUpdated}</p>

          <div className="space-y-8 text-foreground">
            {/* Section 1 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">1. Overview</h2>
              <p className="leading-relaxed">
                Relocation Clarity respects your privacy. This policy explains what information we collect, why we collect it, and how it is used.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">2. Information We Collect</h2>
              <p className="leading-relaxed mb-3">Information you provide:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mb-4">
                <li>Email address</li>
                <li>Assessment responses (preferences, priorities, budget ranges)</li>
                <li>Notes or questions submitted</li>
              </ul>
              <p className="leading-relaxed mb-3">Automatically collected information:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mb-4">
                <li>Basic usage data</li>
                <li>Technical data (browser, device)</li>
              </ul>
              <p className="leading-relaxed">
                We do not collect sensitive personal data such as passport numbers, SSNs, or bank details.
              </p>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">3. Payments</h2>
              <p className="leading-relaxed mb-2">Payments are processed by Stripe.</p>
              <p className="leading-relaxed mb-2">We do not store or access credit card information.</p>
              <p className="leading-relaxed">Stripe's handling of data is governed by Stripe's Privacy Policy.</p>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">4. How We Use Information</h2>
              <p className="leading-relaxed mb-3">We use information to:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mb-4">
                <li>Generate assessment results and Relocation Blueprints</li>
                <li>Improve the service and user experience</li>
                <li>Communicate about accounts or plans</li>
              </ul>
              <p className="leading-relaxed">We do not sell user data.</p>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">5. AI & Data Use</h2>
              <p className="leading-relaxed mb-3">
                We use AI systems to help generate structured guidance based on your inputs.
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Data is used only to provide the service</li>
                <li>We do not sell personal data</li>
                <li>We do not use personal information for advertising</li>
              </ul>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">6. Data Storage & Security</h2>
              <p className="leading-relaxed">
                We use reasonable security practices appropriate for an MVP product. No system is completely secure, but we minimize risk.
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">7. Data Retention</h2>
              <p className="leading-relaxed mb-2">We retain data only as long as necessary.</p>
              <p className="leading-relaxed">Users may request deletion of their account and associated data.</p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">8. Sharing of Information</h2>
              <p className="leading-relaxed mb-3">We share data only with:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mb-4">
                <li>Service providers necessary to operate the platform</li>
                <li>Legal authorities when required</li>
              </ul>
              <p className="leading-relaxed">We do not share data for marketing.</p>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">9. Your Choices</h2>
              <p className="leading-relaxed">
                You may request access, correction, or deletion of your data by using the{" "}
                <Link to="/contact" className="text-primary hover:underline">
                  contact form
                </Link>
                .
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">10. Changes</h2>
              <p className="leading-relaxed">This policy may be updated periodically.</p>
            </section>

            {/* Section 11 */}
            <section>
              <h2 className="font-manrope font-semibold text-xl mb-3">11. Contact</h2>
              <p className="leading-relaxed">
                Privacy questions? Use the{" "}
                <Link to="/contact" className="text-primary hover:underline">
                  contact form
                </Link>
                .
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
